import { render, staticRenderFns } from "./skeleton-hotelroom.vue?vue&type=template&id=af90549e&scoped=true&"
import script from "./skeleton-hotelroom.vue?vue&type=script&lang=js&"
export * from "./skeleton-hotelroom.vue?vue&type=script&lang=js&"
import style0 from "./skeleton-hotelroom.vue?vue&type=style&index=0&lang=css&"
import style1 from "./skeleton-hotelroom.vue?vue&type=style&index=1&id=af90549e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af90549e",
  null
  
)

export default component.exports